var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',[_vm._v(_vm._s(_vm.fee.title))]),_vm._v(" "),_vm._l((_vm.fee.data),function(cardFee,index){return _c('td',{key:index,class:{highlight: _vm.checkLowest(_vm.fee.key, _vm.allCards[index])}},[_c('span',[_vm._v(_vm._s(cardFee))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }